import { EstateFeaturesLanguages, RealEstateFeatures } from '../../@types/types'

// default translation
export const estateFeaturesLanguages: EstateFeaturesLanguages = {
  handicappedAccessible: 'Barrier-free',
  steplessAccessible: 'stepless accessible',
  hasCanteen: 'Canteen/Cafeteria',
  basement: 'Basement',
  kitchenComplete: 'Kitchen available',
  elevator: 'Elevator',
  highVoltage: 'High Voltage',
  ramp: 'Ramp',
  liftingPlatform: 'Lifting Platform',
  balconyTerrace: 'Balcony/Terrace',
  certificateOfEligibilityNeeded: 'Certificate Of Eligibility Needed',
  equippedKitchen: 'Equipped Kitchen',
  flatShareSuitable: 'Flat Share Suitable',
  guestToilet: 'Guest Toilet',
  sharedGarden: 'Shared Garden',
  washingMachine: 'Washing Machine',
  summerResidencePractical: 'Summer Residence Practical',
  lodgerFlat: 'Lodger Flat',
  nonSmoker: 'Non Smoker',
  shortTermConstructible: 'Short Term Constructible',
  buildingPermission: 'Building Permission',
  personElevator: 'Person Elevator',
}

export const realEstateFeaturesWithTranslationKeys = Object.entries(RealEstateFeatures).map((feature) => ({
  translationKey: feature[0],
  property: feature[1],
}))

export const getRealEstateFeatures = (features: RealEstateFeatures[]) => {
  const newResult: { translationKey: string; property: RealEstateFeatures }[] = []
  features.forEach((feature) => {
    if (feature === RealEstateFeatures.STEPLESS_ACCESSIBLE) {
      newResult.push({
        translationKey: 'STEPLESS_ACCESSIBLE',
        property: RealEstateFeatures.HANDICAPPED_ACCESSIBLE,
      })
    } else if (feature === RealEstateFeatures.PERSON_ELEVATOR) {
      newResult.push({
        translationKey: 'PERSON_ELEVATOR',
        property: RealEstateFeatures.ELEVATOR,
      })
    } else {
      newResult.push(realEstateFeaturesWithTranslationKeys.filter((element) => element.property === feature)[0])
    }
  })
  return newResult
}
